import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'components/Loader/Loader';
import { useFetchBundleStats } from 'hooks/useFetchBundles';
import { BundleDataListTable } from 'components/OrderListTable/BundleDataListTable';
import { ReqEnum } from 'const/requestStatus';
import { BundleStats } from '../../types/bundleTypes';
import dayjs from 'dayjs';
import { CalendarFetchOnlyDates } from '../../components/OrderListTable/CalendarFetch/CalendarFetchOnlyDates';
export function BundleReportComposition() {
  const [startDate, setStartDate] = useState(dayjs(new Date()));
  const [endDate, setEndDate] = useState(dayjs(new Date()));

  const fetchValues = values => {
    const { startDate, endDate } = values;
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const [bundles, fetchStatus] = useFetchBundleStats(startDate, endDate);

  return (
    <div>
      <Helmet>
        <title>Reports - Driving</title>
      </Helmet>
      <CalendarFetchOnlyDates fetchValues={fetchValues} />
      {fetchStatus === ReqEnum.PENDING && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Loader type="spinner" size="large" />
        </div>
      )}
      <BundleDataListTable
        bundles={bundles as BundleStats[]}
        fetchStatus={fetchStatus}
      />
    </div>
  );
}
